import { apiService } from "../services/api.service";

export const appController = {
    getLanguageDictionaries,
    getSklady,
    getLanguageDictionariesLastUpdated,
    getLastVersion,
    getLastInformationalVersion
};

function getLanguageDictionaries() {
    return apiService.fetchApiRequest("api/App/GetLanguageDictionaries");
}

function getSklady() {
    return apiService.fetchApiRequest("api/App/GetSklady");
}

function getLanguageDictionariesLastUpdated() {
    return apiService.fetchApiRequest("api/App/GetLanguageDictionariesLastUpdated");
}

function getLastVersion() {
    return apiService.fetchApiRequest("api/App/GetLastVersion");
}

function getLastInformationalVersion() {
    return apiService.fetchApiRequest("api/App/GetLastInformationalVersion");
}



// WEBPACK FOOTER //
// ./src/controllers/app.controller.js